import React from 'react';

import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../ContactModal";

function Main2() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content page-lahalle" style={{background: '#E7ECFF80', position: 'relative', overflow: 'visible'}}>
                <div className="auto-container">
                    <div className="row grid-base align-items-center g-5">
                        <div className="image-column -no-margin col-xl-5 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <figure className="image-box image-responsive" style={{width:'115%'}}>
                                <img src="/images/lahalle/images.webp" alt="Pourquoi ce services" style={{position: 'initial'}} />
                            </figure>
                        </div>
                        <div className="content-column col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <div className="wow fadeInLeft">
                                <div className="sec-title raleway">
                                    <h2 className="fw-700">Pourquoi <span>ce service ?</span></h2>
                                </div>
                                <div className="text nunito">
                                    À La Halle, nous sommes engagés pour que le handicap ne soit jamais un frein injuste
                                    et injustifié à votre emploi et à votre évolution professionnelle. Chacun doit bénéficier
                                    de conditions réalisables adaptées à ses <b>besoins spécifiques</b>,
                                    qui favorisent l’équité et l’égalité des chances, parce que <b>la santé
                                    et le bien-être au travail de tous nos collaborateurs sont nos priorités</b>.
                                    Ce service répond à plusieurs constats:

                                    <div className="text mt-3 mb-3">
                                        <ul className="list-style-disc">
                                            <li>
                                                Le handicap est souvent <b>mal connu</b> et porteur de peurs et de préjugés
                                            </li>
                                            <li>
                                                <b>80% des situations de handicap sont invisibles</b> avec de nombreuses
                                                personnes qui ignorent qu’elles sont en situation de handicap ou préfèrent le cacher
                                            </li>
                                            <li>
                                                Beaucoup pensent à tort ne pas être concernés par le handicap, ou ne connaissent pas bien leurs droits, ou ne savent pas comment bien s’y prendre…
                                            </li>
                                        </ul>
                                    </div>
                                    Cette <b>Hotline Handicap</b> vous permet d’obtenir des réponses concrètes et personnalisées pour disposer de conditions
                                    de travail optimales et adaptées à votre situation, et ainsi limiter les <b>risques sur votre santé et sur votre emploi</b>.

                                </div>

                                <ContactModal textButton="Comment ça marche ?"
                                              showText={false}
                                              small="small"
                                              linkPageContact={false}
                                              iframe={false}
                                              couleur={false}
                                              page="lahalle"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Main2;
